import FileUploadPreview from 'modules/profile/portfolio/quest-applets/FileUploadPreview';
import DecisionTreePreview from 'components/applets/decision-tree-applet/DecisionTreePreview';
import {
  VideoAppletModalPreview,
  QuizAppletModalPreview,
} from '../../modules/profile/components';
import ImageAppletModalPreviewWithConversion from '../../modules/profile/components/ImageAppletModalPreviewWithConversion';
import RankApplet from 'components/applets/rank-applet';
import GroupedAppletModalPreview from '../../modules/profile/portfolio/quest-applets/GroupedAppletModalPreview';
import RandomSelectionAppletProfile from './random-selection-applet-profile';
import MadlibAppletProfile from './madlib-applet-profile';
import QuizAppletProfile from './quiz-applet-profile/index';
import RichTextApplet from 'components/applets/rich-text';
import GenericRichTextApplet from 'components/applets/generic-rich-text';
import { GroupedAppletModalPreviewProps } from 'components/applet-custom-props';

const AppletPreviewSwitch = ({ applet }: GroupedAppletModalPreviewProps) => {
  switch (applet.appletType) {
    case 'upload-image':
      return applet.fileUrl ? (
        <ImageAppletModalPreviewWithConversion src={applet.fileUrl} alt={applet.title} fileType={applet.fileType} />
      ) : null;
    case 'upload-video':
      return <VideoAppletModalPreview src={applet.fileUrl} controls autoPlay />;
    case 'generic-rich-text':
      return <GenericRichTextApplet id={applet.id} initialContent={applet.richText} applet={applet} />
    case 'rich-text-entry':
      return <RichTextApplet initialContent={applet.richText} disabled />;
    case 'inline-text':
      return <RichTextApplet initialContent={applet.text} disabled />;
    case 'upload-file':
    case 'generic-upload-file':
      return (
        <FileUploadPreview applet={applet} />
      );
    case 'quiz':
      return (
        <QuizAppletModalPreview>
          <QuizAppletProfile applet={applet} />
        </QuizAppletModalPreview>
      );
    case 'decision-tree':
      return <DecisionTreePreview files={applet.files} />;
    case 'madlib':
      return <MadlibAppletProfile applet={applet} />;
    case 'rank':
      return (
        <RankApplet
          appletId={applet.contentfulId}
          optionsContentful={applet.optionsContentful!}
          options={applet.options}
          forcedDisabled
        />
      );
    case 'group-applet':
      return <GroupedAppletModalPreview applet={applet} />;
    case 'random-selection':
      return <RandomSelectionAppletProfile applet={applet} />;
    default:
      return null;
  }
};


export default AppletPreviewSwitch;
